import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IConsumableWarehouseState } from './consumable-warehouse';

const consumableWarehouseStateSelector = createFeatureSelector<IConsumableWarehouseState>('consumableWarehouse');

export const selectCatalogoAppartenenza = createSelector(
  consumableWarehouseStateSelector,
  (state: IConsumableWarehouseState) => state.responseCatalogoAppartenenza
);

export const selectApprovvigionamentoOrdine = createSelector(
  consumableWarehouseStateSelector,
  (state: IConsumableWarehouseState) => state.responseApprovvigionamentoOrdine
);

export const selectApprovvigionamentoProdotti = createSelector(
  consumableWarehouseStateSelector,
  (state: IConsumableWarehouseState) => state.responseApprovvigionamentoProdotti
);

export const selectApprovvigionamentoOrdineFinale = createSelector(
  consumableWarehouseStateSelector,
  (state: IConsumableWarehouseState) => state.responseApprovvigionamentoOrdineFinale
);

export const selectCatalogoAppartenenzaReso = createSelector(
  consumableWarehouseStateSelector,
  (state: IConsumableWarehouseState) => state.responseCatalogoAppartenenzaReso
);

export const selectProdottiReso = createSelector(
  consumableWarehouseStateSelector,
  (state: IConsumableWarehouseState) => state.responseProdottiReso
);

export const selectGenerateBarcodeScatolaReso = createSelector(
  consumableWarehouseStateSelector,
  (state: IConsumableWarehouseState) => state.responseGenerateBarcodeScatolaReso
);

export const selectCreaReso = createSelector(
  consumableWarehouseStateSelector,
  (state: IConsumableWarehouseState) => state.responseCreaReso
);

export const selectStoricoOrdiniMateriali = createSelector(
  consumableWarehouseStateSelector,
  (state: IConsumableWarehouseState) => state.responseStoricoOrdiniMateriali
);

export const selectEsportaStoricoOrdini = createSelector(
  consumableWarehouseStateSelector,
  (state: IConsumableWarehouseState) => state.responseEsportaStoricoOrdini
);

export const selectMailStoricoOrdini = createSelector(
  consumableWarehouseStateSelector,
  (state: IConsumableWarehouseState) => state.responseMailStoricoOrdini
);

export const selectProductsBoxAcceptance = createSelector(
  consumableWarehouseStateSelector,
  (state: IConsumableWarehouseState) => state.responseProductsBoxAcceptance
);





